import * as React from 'react';
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import {setInfoPrice} from '../../../redux/reduces/skuSlice'
import * as AnimateNumber from '@alife/bc-animate-number';
import DeliveryDay from './delivery-day';
import OrderTable from './order-table';

export default function MoqPrice ( props: any ) {
  const {
    price,
    moq,
    quantity,
    i18n,
    type,
    warehouseLeadTimeInfo = {},
    children,
    dispatchId
  } = props;

  if (!price) return null;

  const {
    productLadderPrices,
    promotionFixedPrice,
    fixedPrice,
    productRangePrices,
    unit,
    unitEven,
    currencyRule: {
      rate,
      currencyPattern,
      maximumFractionDigits,
     }
  } = price;

  const dispatch = useAppDispatch();

  const skuInfo = useAppSelector( state =>  state.sku[type]);
  const selectSkuInfo = Object.values(skuInfo.map).filter((i:any) => i.number > 0);

  const {price: skuPrice, totalPrice} = skuInfo;
  const ladderPeriodList = warehouseLeadTimeInfo[dispatchId] || warehouseLeadTimeInfo["DEFAULT"];
  
  // 更新现货价格初始化
  const setPricePrice = (skuPrice: number) => {
    dispatch(setInfoPrice({
      type,
      price: skuPrice,
      formatPrice: currencyPattern.replace( "{0}", (skuPrice * rate).toFixed( maximumFractionDigits )),
      totalPrice: selectSkuInfo.reduce((a: number, {number = 0, price = 0}) => a + (price || skuPrice) * number, 0),
      quantity,
    }))
  }
  
  // 获取商品价格
  const getProductPrice = () => {
    // 获取区间价格
    if ( productRangePrices ) {
      const { priceRangeLow,priceRangePromotionLow } = productRangePrices;
      return setPricePrice( priceRangePromotionLow || priceRangeLow );
    }
    // 阶梯价
    if ( productLadderPrices ) {
      let ladderPrice = {
        promotionPrice: '',
        price: '',
      } as any;
      // 小于moq
      if ( quantity > moq ) {
        productLadderPrices.forEach( (p: any) => {
          if ( quantity >= p.min ) {
            if ( p.max === -1 || quantity <= p.max ) {
              ladderPrice = p;
            }
          }
        } );
      } else {
        ladderPrice = productLadderPrices[0];
      }
      const { promotionPrice } = ladderPrice;
      return setPricePrice( promotionPrice || ladderPrice.price );
    }

    // 促销价
    if ( fixedPrice ) {
      return setPricePrice( promotionFixedPrice || fixedPrice );
    }
  };

  // 当商品数量变更，价格都会动态调整
  getProductPrice();

  const mathPrice = () => {
    if ( quantity >= moq ) {
      return currencyPattern.replace(
        '{0}',
        ( totalPrice * rate).toFixed( maximumFractionDigits ),
      );
    }
    return currencyPattern.replace( '{0}',( skuPrice * moq *  rate).toFixed( maximumFractionDigits ) );
  };

  return (
    <div
      className="express-item"
      style={{
        borderTopWidth: 0,
      }}
    >
      {quantity < moq && (
        <div className="item-tips">
          {i18n['202107_detail_pc_ShippingFloor_MOQ'].replace(
            '{0}',
            `${moq} ${unit}`,
          )}
        </div>
      )}
      <div className="item-left">
        {quantity < moq ? (
          <span className="ext">
            {quantity}/{moq} {unit}
          </span>
        ) : (
          <span className="ext">
            {quantity} {unitEven}
          </span>
        )}
        {quantity > 0 && <OrderTable {...props}/>}
      </div>
      <div className="item-right">
        {moq > quantity && (
          <span className="normal">
            {i18n['202107_detail_pc_ShippingFloor_LowestPrice']}
          </span>
        )}
        <span className="price">
          <AnimateNumber value={mathPrice()} />
        </span>
      </div>
      <DeliveryDay i18n={i18n} moq={moq} ladderPeriodList={ladderPeriodList} quantity={quantity}/>
      {children}
    </div>
  );
}
